export const PUBLIC_FORM_SUBMISSION_OUTCOME_KEY = 'labwick.publicForm.submissionOutcome';

export type PublicFormSubmissionOutcomeState = {
  token: string;
  formTitle?: string | null;
  /** True when the server overwrote an existing row (message "Submission updated"). */
  updated: boolean;
  successMessageHtml?: string | null;
  apiMessage: string;
};
